module.exports = __webpack_public_path__ + "img/dashboard-blue.0900f550.svg";